// extracted by mini-css-extract-plugin
export default {"actionSection":"confirmationDialog_actionSection__6G1d9"};